import { Button, Icon, Spacing, TextInput } from 'zens-storybook'
import React, { Suspense, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, TouchableOpacity, View } from 'react-native'
import { AccessType } from 'zens-store'
import { useNumberParams, usePaginationParam, Link } from 'zens-router'
import { useBreadcrumb, usePermissions } from '@dms/hook'
import { LayoutHeader, ScheduleTable } from '@dms/component'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    flex: 1,
    margin: Spacing.L,
  },
  header: {
    flexDirection: 'row',
  },
  search: {
    minWidth: 300,
    marginRight: Spacing.S,
  },
})

const ScreenScheduleList = () => {
  const [search, setSearch] = useState('')
  const { t } = useTranslation()
  const [{ companyId }] = useNumberParams()
  const [pagination, setPagination] = usePaginationParam()
  const { hasPermission } = usePermissions(companyId)

  const breadcrumb = useBreadcrumb([
    {
      title: t('Workspaces'),
      href: `/companies/${companyId}/workspaces`,
    },
    {
      title: t('Schedules'),
    },
  ])

  function updateSearch(search: string) {
    setSearch(search)
    setPagination({ page: 0, size: pagination.size })
  }

  const renderHeader = () => {
    return (
      <View style={styles.header}>
        <TextInput
          left="search"
          placeholder={t('Search schedule name')}
          right={
            search ? (
              <TouchableOpacity onPress={() => updateSearch('')} testID="ScheduleList.Search.Clear">
                <Icon name="close" size="S" />
              </TouchableOpacity>
            ) : undefined
          }
          value={search}
          onChangeText={updateSearch}
          style={styles.search}
          testID="ScheduleList.Search"
        />
        {hasPermission(AccessType.Update, 'workspace') && (
          <Link href={`/companies/${companyId}/workspaces/schedules/add`} asChild>
            <Button title={t('Add schedule')} left="plus" testID="ScheduleList.Add" />
          </Link>
        )}
      </View>
    )
  }

  return (
    <View style={styles.container}>
      <LayoutHeader breadcrumb={breadcrumb} title={t('Schedules')} accessory={renderHeader()} />
      <View style={styles.content}>
        <Suspense fallback={<ScheduleTable.Skeleton />}>
          <ScheduleTable
            companyId={companyId}
            search={search}
            pagination={pagination}
            onPaginationChange={setPagination}
          />
        </Suspense>
      </View>
    </View>
  )
}

export default ScreenScheduleList
